import { v4 as uuidv4 } from 'uuid';
import { useCreateImages, useNetwork } from '@tribeplatform/react-sdk/hooks';
import { fileSizeLimitError, linkToFile } from '../../common/lib/upload';
import { useI18n } from '../../i18n';
import { setNodeAttrById } from '../helpers/node';
import { composerError } from '../utils/errors';
export const useHandlePaste = () => {
    const intl = useI18n();
    const { data: network } = useNetwork();
    const { mutateAsync: createImages } = useCreateImages();
    const handlePaste = (view, event, slice) => {
        const imageNodes = [];
        // find the async-image nodes and prepare for upload
        slice.content.forEach(node => {
            if (node.type.name === 'async-image') {
                const tempId = uuidv4();
                node.attrs.loading = true;
                node.attrs.id = tempId;
                imageNodes.push({ node, id: tempId });
            }
        });
        if (!imageNodes.length)
            return false;
        imageNodes.forEach(async ({ node, id: tempId }) => {
            var _a, _b;
            const { src } = node.attrs;
            // fetch the src into a file
            const file = await linkToFile(src, intl);
            // throw an error if the file size is exceed the limit
            if (!file)
                return;
            if (file.size > ((_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.imageSizeLimit)) {
                //
                composerError(intl)(fileSizeLimitError((_b = network === null || network === void 0 ? void 0 : network.settings) === null || _b === void 0 ? void 0 : _b.imageSizeLimit, 'image', intl));
                return;
            }
            // upload the file
            const [{ url, id }] = await createImages([{ file }]);
            const nodeType = view.state.schema.nodes['async-image'];
            // reset the node attributes
            setNodeAttrById(view, nodeType, tempId, {
                id,
                src: url,
                loading: false,
            });
        });
        return false;
    };
    return {
        handlePaste,
    };
};
//# sourceMappingURL=useHandlePaste.js.map